import { render, staticRenderFns } from "./td-quarternary.vue?vue&type=template&id=c3808b52&scoped=true"
import script from "./td-quarternary.vue?vue&type=script&lang=js"
export * from "./td-quarternary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3808b52",
  null
  
)

export default component.exports